import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Api } from '../../providers/api';
import {GVLogger} from "../../services/gv-logger";
import {LoginPage} from "../login/login";
import {MsgManager} from "../../providers/msg-manager";
// $IMPORTSTATEMENT

/**
 * Generated class for the LocationsListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
// $IONICPAGE
@Component({
  selector: 'page-locations-list',
  templateUrl: 'locations-list.html',
})
export class LocationsListPage {

  items = [];
  private searchStatus: boolean = false;
  searchString = "";
  @ViewChild('barcodeFocus') barCodeFocusInput ;

  constructor(public navCtrl: NavController, private msgManager: MsgManager,public navParams: NavParams, private viewCtrl:ViewController, public api:Api, private gVLogger: GVLogger) {
    this.items = this.navParams.get("items");
    this.searchString = this.navParams.get("searchString");
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad LocationsListPage');
    setTimeout(() => {
      // Keyboard.show() // for android
      // if(!Constants.isWebstore){
      // alert("sada");
      this.barCodeFocusInput.setFocus();
      // }
    },800);
  }

  supplierSelected(selected: string) :void {
    this.gVLogger.log("supplierSelected : " + selected);
    this.viewCtrl.dismiss(selected);
    // this.reference = selected;
    // this.items = [];
    // this.resultsAvailable = false;
    // this.ignoreNextChange = true;
    // this.gVLogger.log("supplierSelected..... ");
    // this.gVLogger.log("supplierSelected : " + selected);
    //
    // this.gVLogger.log("reference : " + this.reference);
    // this.gVLogger.log("items in cart : " + this.cart.items.length);
    // this.items = [];
    // if(this.reference !== null && this.cart.items.length >= 1){
    //   this.referenceStatus = false;
    // }
  }

  close(){
    this.viewCtrl.dismiss();
  }


  onInputChange(event: any) {
    this.searchStatus = false;
    let substring = event.target.value;

    // if(this.productRefSearch === 1){
    // //   this.api.get("products/getproductReferencesByProductId/" + substring+"?productId="+this.productId).map(res => res.json()).subscribe(data => {
    // //     if (data.status === "200") {
    // //       this.items = [];
    // //       for (let item of data.data) {
    // //         this.items.push(item.referenceNo);
    // //         this.gVLogger.log("daaaattaaaaa : " + this.items);
    // //       }
    // //     } else {
    //   this.gVLogger.log("product ref search : " + this.searchStatus);
    //       this.items = [];
    //       this.searchStatus = true;
    // //     }
    //   this.gVLogger.log("product ref search : " + this.searchStatus);
    // //   })
    // }
    // else {
      if (substring.trim() == "") {
        substring = "-1";
      }
      this.api.get("products/getLocationsByAdpCustomerId/?searchString=" + substring)
      // this.api.get("products/getProductByBarcode/"+event.target.value)
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.navCtrl.setRoot(LoginPage);
          }
            if (data.status === "200") {
              this.items = [];
              for (let item of data.data) {
                this.items.push(item.locationCode);
                this.gVLogger.log("daaaattaaaaa : " + this.items);
              }
              this.searchStatus = false;
              if(this.items.length === 1){
                this.viewCtrl.dismiss(this.items[0]);
              }
            } else {
              this.items = [];
              this.searchStatus = true;
              this.gVLogger.log("else case when no data found : " + this.searchStatus);
            }
        });
    // }
  }

}



// WEBPACK FOOTER //
// ./src/pages/locations-list/locations-list.ts